export default __webpack_public_path__ + "static/media/training.3937ac7e.jpeg";